import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { getUtcDisplayDate } from "encamp-shared/src/utils/date";
import { Control, Controller } from "react-hook-form";

import { prettyPrintWasteStreamRegistrationStatus } from "../../prettyPrintWasteStreamRegistrationStatus";
import { RegistrationStream } from "./registrationSource";

interface RegistrationSourcePickerProps {
  control: Control<any>;
  candidates: RegistrationStream[];
}

function statusLabel(status: string | null | undefined): string {
  if (status == null) return "No status";
  return prettyPrintWasteStreamRegistrationStatus(status);
}

function dateLabel(at: string | null | undefined): string {
  if (at == null) return "No date";
  return getUtcDisplayDate(at, "short");
}

function optionLabel(candidate: RegistrationStream): string {
  const registration = candidate.registration;
  // Nothing to describe the registration by — surface the link plainly rather
  // than "— · No status · No date". The stream name (appended by the caller)
  // identifies which one.
  if (!registration) return "Linked registration";
  return `${registration.stateRegisteredId ?? "—"} · ${statusLabel(
    registration.status
  )} · ${dateLabel(registration.registeredAt)}`;
}

export const RegistrationSourcePicker = ({
  control,
  candidates,
}: RegistrationSourcePickerProps) => {
  return (
    <FormControl component="fieldset" sx={{ width: "100%" }}>
      <Stack spacing={1}>
        <FormLabel component="legend">State registration</FormLabel>
        <Alert severity="warning">
          These waste streams have different state registrations. Choose which one the merged stream
          keeps — the others will be discarded.
        </Alert>
        <Controller
          control={control}
          name="stateRegistrationSourceWasteStreamId"
          render={({ field }) => (
            <RadioGroup {...field} value={field.value ?? ""}>
              {candidates.map((candidate) => (
                <FormControlLabel
                  key={candidate.id}
                  value={candidate.id}
                  control={<Radio />}
                  label={
                    <Typography component="span">
                      {optionLabel(candidate)}{" "}
                      <Typography component="span" sx={{ color: "text.secondary" }}>
                        ({candidate.name})
                      </Typography>
                    </Typography>
                  }
                />
              ))}
            </RadioGroup>
          )}
        />
      </Stack>
    </FormControl>
  );
};
